// Call Center API Service
import { TICKET_API } from './index';

// Route via API Gateway to hd-callcenter
// Gateway predicate configured as: /gateway/callcenter/**
const base = '/gateway/callcenter';

export const callcenterService = {
  // Users
  async getUsers() {
    const res = await TICKET_API.get(`${base}/api/users`);
    return res.data;
  },
  async createUser(payload) {
    // payload: { extension, password }
    const res = await TICKET_API.post(`${base}/api/users`, payload);
    return res.data;
  },
  async deleteUser(ext) {
    const res = await TICKET_API.delete(`${base}/api/users/${encodeURIComponent(ext)}`);
    return res.data;
  },

  // Queue
  async addToQueue(ext) {
    const res = await TICKET_API.post(`${base}/api/queue/add`, null, {
      params: { ext }
    });
    return res.data;
  },
  async removeFromQueue(ext) {
    const res = await TICKET_API.post(`${base}/api/queue/remove`, null, {
      params: { ext }
    });
    return res.data;
  },
  async getQueueStatus() {
    const res = await TICKET_API.get(`${base}/api/queue/status`, {
      responseType: 'text'
    });
    // Axios may parse as string already; ensure string
    return typeof res.data === 'string' ? res.data : JSON.stringify(res.data, null, 2);
  },
};

export default callcenterService;

